import type { RequestConfig } from '@customTypes/index';
import type { ArtistParametersDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistPostProfileParametersRequest = {
  profileId: string;
  data: ArtistParametersDto;
};

type ConfirmEmailResponse = {
  message: string;
  confirmationCode: string;
};
export type ArtistPostProfileParametersParams =
  RequestConfig<ArtistPostProfileParametersRequest>;

export const artistPostProfileParameters = async ({
  params,
  config
}: ArtistPostProfileParametersParams) =>
  api.post<ConfirmEmailResponse>(
    `/api/ArtistProfile/${params.profileId}/parameters`,
    params.data,
    config
  );
